// extracted by mini-css-extract-plugin
export default {"-large":"n0A6d2NwvZxmEhS2p46T","smallTool":"lyIk43_bHRsMIxLJbcqJ","bigTool":"EVRCCAS8XbmaK_kQy585"};